function Input({
  validate = () => '',
  value,
} = {}) {
  let hasValidated = false
  let errorMessage = ''
  let errorRequiresChange = false

  let maxLength = null
  let minLength = null
  let minValue = null
  let isRequired = false
  let type = null
  let step = null
  let ownerForm = null
  return {
    bindToForm(f) {
      ownerForm = f
    },
    errorMessage() {
      return errorMessage
    },
    isInvalid() {
      return errorMessage !== ''
    },
    isValid() {
      return errorMessage === ''
    },
    getValue() {
      return value
    },
    setValue(x, { validate = false } = {}) {
      if (type === 'number') {
        value = Number(x)
      } else {
        value = String(x)
      }
      if (validate && ownerForm) {
        ownerForm.validateInputs()
      }
    },
    getReference(el) {
      isRequired = el.required || (el.type === 'radio')
      maxLength = el.maxLength
      minLength = el.minLength
      minValue = el.min && Number(el.min)
      step = Number(el.step)
      type = el.type
      if (
        value === undefined
        && ((type !== 'radio' && type !== 'checkbox') || el.checked)
      ) {
        if (type === 'number') {
          value = Number(el.value)
        } else {
          value = el.value
        }
      }
    },
    handleEvent(event) {
      if (
        event.type === 'input'
        && value !== event.target.value
      ) {
        errorRequiresChange = false
        if (type === 'number') {
          value = event.target.value && Number(event.target.value)
        } else {
          value = event.target.value
        }
        if (ownerForm) {
          ownerForm.validateInputs()
        } else if (hasValidated) {
          this.validate()
        }
      }
    },
    setError(message = '') {
      errorMessage = message
      errorRequiresChange = true
    },
    validate() {
      hasValidated = true

      if (isRequired && value.length === 0) {
        errorMessage = 'This field is required'
      } else if (maxLength > 0 && value.length > maxLength) {
        errorMessage = `Must be at most ${maxLength} characters`
      } else if (minLength !== null && value.length < minLength) {
        errorMessage = `Must be at least ${minLength} characters`
      } else if (type === 'email' && !value.includes('@')) {
        errorMessage = 'This does not look like an email address'
      } else if (type === 'number' && minValue > value) {
        errorMessage = `Must be greater than ${minValue - 1}`
      } else if (type === 'number' && Number.isNaN(value)) {
        errorMessage = 'Must be a number'
      } else if (type === 'number' && step === 1 && value !== Math.floor(value)) {
        errorMessage = 'Must be an integer'
      } else if (!errorRequiresChange) {
        errorMessage = validate(value) || ''
      }
    },
    __proto__: Input.prototype,
  }
}

function RadioInput({ values, ...opts }) {
  const _super = Input(opts)
  const options = values.reduce((options, value) => ({
    ...options,
    [value]: {
      isChecked: () => _super.getValue() === value
    }
  }), {})

  return {
    ..._super,
    ...options,
    values,
    __proto__: RadioInput.prototype,
  }
}

function CheckboxInput({ validate = () => '' } = {}) {
  let hasValidated = false
  let errorMessage = ''
  let errorRequiresChange = false

  let value
  let isRequired = false
  let ownerForm = null
  return {
    bindToForm(f) {
      ownerForm = f
    },
    errorMessage: () => errorMessage,
    isInvalid: () => errorMessage !== '',
    isValid: () => errorMessage === '',
    getValue: () => value,
    setValue(x) {
      value = Boolean(x)
      if (ownerForm) {
        ownerForm.validateInputs()
      }
    },
    getReference(el) {
      isRequired = el.required
      value = el.checked
    },
    handleEvent(event) {
      if (event.type === 'input') {
        errorRequiresChange = false

        value = event.target.checked

        if (ownerForm) {
          ownerForm.validateInputs()
        } else if (hasValidated) {
          this.validate()
        }
      }
    },
    setError(message = '') {
      errorMessage = message
      errorRequiresChange = true
    },
    validate() {
      hasValidated = true

      if (isRequired && value === false) {
        errorMessage = 'This field is required'
      } else if (!errorRequiresChange) {
        errorMessage = validate(value) || ''
      }
    },
    __proto__: CheckboxInput.prototype,
  }
}

Object.assign(exports, { CheckboxInput, Input, RadioInput })
